<template>
        <div v-if="companies.length > 0 && promotionSectorsSet">
            <div>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom"
                    >Holiday</v-col
                >
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select
                    :items="holiday_types"
                    v-model="holiday"
                    outlined
                    dense
                    />
                </v-col>
                </v-row>
                <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom"
                    >Sale Type</v-col
                >
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select
                    :items="sale_types"
                    v-model="sale_type"
                    outlined
                    dense
                    />
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Promotion Company</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-select
              :items="promotion_companies"
              v-model="promotion_company"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Product Type</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-select
              :items="product_types"
              v-model="product_type"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <div>
            <v-row v-if="!editMode && promotions.length">
            <v-col
            :cols="4"
            class="label-field text-left no-right no-bottom"
            >Promotions :</v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top">
            <div class="flex" >
                <div style="margin-bottom:15px;">
                    <v-simple-table fixed-header  dense style="width:562px;max-height:400px;overflow:scroll">
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left" style="width:10%">
                            Sr. No.
                        </th>
                        <th class="text-left"  style="width:40%">
                            Promotion Company
                        </th>
                        <th class="text-left"  style="width:30%">
                            Product Type
                        </th>
                        <th class="text-left" style="width:20%">
                            Actions
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(item, i) in promotions"
                        :key="item.name"
                        >
                        <td>{{i+1}}</td>
                        <td>{{getCompanyName(item.promotion_company)}}</td>
                        <td>{{getProductName(item.product_type)}}</td>
                        <td>
                        <div class="d-inline">
                                    <v-icon
                            data-inline="true"
                            style="cursor:pointer;"
                            title="Edit Promotion"
                            @click.prevent="editPromotion(i)"
                            >mdi-pencil</v-icon
                            >
                            <v-icon
                            style="cursor:pointer;"
                            data-inline="true"
                            title="Delete Promotion"
                            @click.prevent="removePromotion(i)"
                            >mdi-delete</v-icon
                            >
                        </div>
                        </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
                </div>
            </div>
            </v-col>
        </v-row>
            <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-btn v-if="!openPromotion && promotion_company && product_type" small color="primary" @click="toggleAddPromotion"
                >Add Promotion</v-btn
            >
            <div v-if="openPromotion && promotion_company && product_type">
                <v-row  id="product__rowpadding" style="margin-bottom:15px;">
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        <span v-if="!editMode">
                            Promotion #{{promotions.length+1}}
                        </span>
                        <span v-else>
                            Promotion #{{promotion_no+1}}
                        </span>
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <span v-if="!editMode">
                            {{getCompanyName(promotion_company)}}
                        </span>
                        <span v-else>
                            {{getCompanyName(promotion.promotion_company)}}
                        </span>
                    </v-col>
                </v-row>
                <v-row  id="product__rowpadding"  style="margin-bottom:15px;">
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Product Type
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <span v-if="!editMode">
                            {{getProductName(product_type)}}
                        </span>
                        <span v-else>
                            {{getProductName(promotion.product_type)}}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">Promotion Type</v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select
                :items="promotion_types"
                v-model="promotion.promotion_type"
                outlined
                dense
                />
                </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Coupon/Discount Value
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-text-field outlined dense v-model="promotion.discount_value"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Ad Price ($)
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-text-field outlined dense v-model="promotion.ad_price"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Regular Price ($)
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-text-field outlined dense v-model="promotion.regular_price"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Shipping Detail
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-select
                    :items="shipping_details"
                    v-model="promotion.shipping_detail"
                    outlined
                    dense
                    />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Online/In Store
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-select
                    :items="store_types"
                    v-model="promotion.store_type"
                    outlined
                    dense
                    />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Qualifier
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-select
                    :items="qualifier_types"
                    v-model="promotion.qualifier_type"
                    outlined
                    dense
                    />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Qualifier (Minimum Purchase Value $)
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-text-field outlined dense v-model="promotion.qualifier_min_purchase_value"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Code Required
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-select
                    :items="yes_no_options"
                    v-model="promotion.code_required"
                    outlined
                    dense
                    />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        BOGO
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-select
                    :items="yes_no_options"
                    v-model="promotion.bogo"
                    outlined
                    dense
                    />
                    </v-col>
                </v-row>
                <div v-if="promotion.bogo == 1">
                    <v-row>
                    <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                        Buy [X]
                    </v-col>
                    <v-col :cols="6" class="text-left no-left no-bottom no-top">
                        <v-text-field outlined dense v-model="promotion.buy_x"/>
                    </v-col>
                    </v-row>
                    <v-row>
                        <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align">
                            Get [X]
                        </v-col>
                        <v-col :cols="6" class="text-left no-left no-bottom no-top">
                            <v-text-field outlined dense v-model="promotion.get_x"/>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col :cols="3"></v-col>
                    <v-col :cols="6">
                        <v-row>
                            <v-col :cols="6">
                                <div v-if="editMode">
                                    <v-btn small color="primary"  @click="updatePromotion()">Update</v-btn>
                                </div>
                                <div v-else>
                                    <v-btn small color="primary"  @click="savePromotion()">Save Promotion</v-btn>
                                </div>
                            </v-col>
                            <v-col :cols="6">
                                <v-btn small color="default" style="margin-left:15px;" @click.prevent="close()">Cancel</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            </v-col>
        </v-row>
        </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
//import AddPromotion from "./AddPromotion";
export default {
    name: 'Promotion',
    data: () => ({
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        editMode:false,
        editNode:null,
        promotion_company:null,
        promotion_no:0,
        product_type:null,
        openPromotion:false,
        yes_no_options: [{text:'Select One',value:''},{text:'Yes',value:1},{text:'No',value:2}],
        promotion: {
            promotion_company:null,
            product_type:null,
            promotion_type: '',
            discount_value: '',
            ad_price: '',
            regular_price: '',
            shipping_detail: '',
            store_type: '',
            qualifier_type: '',
            qualifier_min_purchase_value: '',
            code_required: '',
            bogo: '',
            buy_x: '',
            get_x: '',
        }
    }),
    props : [
        "promotionSectorsSet"
    ],
    components: {
        //AddPromotion,
    },
    methods: {
        toggleAddPromotion() {
            this.openPromotion = !this.openPromotion;
        },
        close: function() {
            this.promotion = {
                promotion_company:null,
                product_type:null,
                promotion_type: '',
                discount_value: '',
                ad_price: '',
                regular_price: '',
                shipping_detail: '',
                store_type: '',
                qualifier_type: '',
                qualifier_min_purchase_value: '',
                code_required: '',
                bogo: '',
                buy_x: '',
                get_x: '',
            }
            this.editMode = false
            this.editNode = null
            this.openPromotion = false;
        },
        savePromotion: function(){
            let new_promotion = this.promotion
            if(new_promotion.promotion_type == ''){
                this.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title: "Please select promotion type!",
                });
                return false;
            }
            let addable = false
            let all_promotions = this.$store.getters["ProductData/getPromotions"]
            new_promotion.promotion_company = this.promotion_company
            new_promotion.product_type = this.product_type
            if(all_promotions.length){
                let current_combination_counts = []
                all_promotions.forEach((p)=>{
                    if(p.promotion_company == new_promotion.promotion_company && p.product_type == new_promotion.product_type){
                        current_combination_counts.push(1)
                    }
                })
                if(current_combination_counts.length < 10){
                    addable = true
                }
            }else{
                addable = true
            }
            if(addable == true){
                all_promotions.push(new_promotion)
                this.$store.dispatch("ProductData/setPromotions", [])
                this.$store.dispatch("ProductData/setPromotions", all_promotions)
                this.promotion = {
                    promotion_company:null,
                    product_type:null,
                    promotion_type: '',
                    discount_value: '',
                    ad_price: '',
                    regular_price: '',
                    shipping_detail: '',
                    store_type: '',
                    qualifier_type: '',
                    qualifier_min_purchase_value: '',
                    code_required: '',
                    bogo: '',
                    buy_x: '',
                    get_x: '',
                }
                this.openPromotion = false;
            }else{
                this.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title: "Maximium 10 promotions allowed for a company and product type!",
                });
            }
            

        },
        editPromotion: function(i){
            let all_promotions = this.$store.getters["ProductData/getPromotions"]
            this.promotion.promotion_company = all_promotions[i].promotion_company
            this.promotion_company = all_promotions[i].promotion_company
            this.promotion.product_type = all_promotions[i].product_type
            this.product_type = all_promotions[i].product_type
            this.promotion.promotion_type = all_promotions[i].promotion_type
            this.promotion.discount_value = all_promotions[i].discount_value
            this.promotion.ad_price = all_promotions[i].ad_price
            this.promotion.regular_price = all_promotions[i].regular_price
            this.promotion.shipping_detail = all_promotions[i].shipping_detail
            this.promotion.store_type = all_promotions[i].store_type
            this.promotion.qualifier_type = all_promotions[i].qualifier_type
            this.promotion.qualifier_min_purchase_value = all_promotions[i].qualifier_min_purchase_value
            this.promotion.code_required = all_promotions[i].code_required
            this.promotion.bogo = all_promotions[i].bogo
            this.promotion.buy_x = all_promotions[i].buy_x
            this.promotion.get_x = all_promotions[i].get_x

            this.promotion_no = i

            this.editMode = true
            this.editNode = i
            this.openPromotion = true;

        },
        updatePromotion: function(){
            let all_promotions = this.$store.getters["ProductData/getPromotions"]
            let i = this.editNode
            all_promotions[i].promotion_company  = this.promotion.promotion_company 
            all_promotions[i].product_type  = this.promotion.product_type 
            all_promotions[i].promotion_type  = this.promotion.promotion_type 
            all_promotions[i].discount_value = this.promotion.discount_value
            all_promotions[i].ad_price = this.promotion.ad_price
            all_promotions[i].regular_price = this.promotion.regular_price
            all_promotions[i].shipping_detail = this.promotion.shipping_detail
            all_promotions[i].store_type = this.promotion.store_type
            all_promotions[i].qualifier_type = this.promotion.qualifier_type
            all_promotions[i].qualifier_min_purchase_value = this.promotion.qualifier_min_purchase_value
            all_promotions[i].code_required = this.promotion.code_required
            all_promotions[i].bogo = this.promotion.bogo
            all_promotions[i].buy_x = this.promotion.buy_x
            all_promotions[i].get_x = this.promotion.get_x

            this.$store.dispatch("ProductData/setPromotions", [])
            this.$store.dispatch("ProductData/setPromotions", all_promotions)

            this.promotion = {
                promotion_company:null,
                product_type:null,
                promotion_type: '',
                discount_value: '',
                ad_price: '',
                regular_price: '',
                shipping_detail: '',
                store_type: '',
                qualifier_type: '',
                qualifier_min_purchase_value: '',
                code_required: '',
                bogo: '',
                buy_x: '',
                get_x: '',
            }

            this.editMode = false
            this.editNode = null
            this.openPromotion = false;

        },
        removePromotion: function(i){
            let view = this
            view.$swal
            .fire({
              title: "Are you sure you want to remove promotion?",
            //   text:
            //     "This will clear all Sector/Category/Sub-category dependant fields.",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, remove it !",
              cancelButtonText: "No, cancel !",
              closeOnConfirm: false,
              closeOnCancel: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                let all_promotions = this.$store.getters["ProductData/getPromotions"]
                let newPromotions = all_promotions.filter(
                    (o,z) => z !== i
                );
                this.$store.dispatch("ProductData/setPromotions", [])
                this.$store.dispatch("ProductData/setPromotions", newPromotions)
              } else if (result.isDenied) {
                view.$swal.fire(
                  "Cancelled",
                  "Promotion was not removed !",
                  "error"
                );
              }
            });
            

        },
        getCompanyName:function(id){
            let name = ''
            let all_companies = this.$store.getters["ProductData/getCompanies"]
            all_companies.forEach((c)=>{
                if(c.companyID == id){
                    name = c.companyName
                }
            })
            return name
        },
        getProductName: function(id){
            let name = ''
            let all_products = this.product_types
            all_products.forEach((c)=>{
                if(c.value == id){
                    name = c.text
                }
            })
            return name
        }
    },
    watch: {
        promotionSectorsSet: function(o){
            console.log(o)
            if(o === false){
                this.promotion_company = null
                this.product_type = null
                this.$store.dispatch("ProductData/setPromotions", [])
            }
        }
    },
    computed: {
        ...mapGetters({
            states: "ProductData/getProductStates",
            media_chan: 'ProductData/getStateMediaChannel',
            companies: 'ProductData/getCompanies',
            promotions : 'ProductData/getPromotions',
            promotion_types : 'ProductData/getAllPromotionTypes',
            shipping_details : 'ProductData/getAllPromotionShippingDetails',
            store_types : 'ProductData/getAllPromotionOnlineInstores',
            qualifier_types : 'ProductData/getAllPromotionQualifiers',
            sale_types : 'ProductData/getAllPromotionSaleTypes',
            holiday_types : 'ProductData/getAllPromotionHolidays',
        }),
        promotion_companies : function() {
            let promotion_companies = [{text:'Select One', value: null}]
            let selected_companies = this.$store.getters["ProductData/getCompanies"];
            if(selected_companies.length){
                selected_companies.forEach((c)=>{
                promotion_companies.push({text:c.companyName,value:c.companyID});
                })
            }
            return promotion_companies
        },
        product_types : function() {
            let product_types = [{text:'Select One', value: null}]
            let selected_companies = this.$store.getters["ProductData/getSector"];
            if(selected_companies.length){
                selected_companies.forEach((c)=>{
                    if(c[0].id === 266 || c[0].id === 559 || c[0].id === 560){
                        if(c.length == 2){
                            product_types.push({text:c[1].name,value:c[1].id});
                        }
                        if(c.length == 3){
                            product_types.push({text:c[2].name,value:c[2].id});
                        }
                        if(c.length == 4){
                            product_types.push({text:c[3].name,value:c[3].id});
                        }
                    }
                
                })
            }
            return product_types
        },
        holiday:{
            get: function () {
                return this.$store.getters["ProductData/getHoliday"];
            },
            set: function (o) {
                this.$store.dispatch("ProductData/setHoliday", o);
            },
        },
        sale_type: {
            get: function() {
                return this.$store.getters['ProductData/getSaleType']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setSaleType', o)
            },
        },
    }
}
</script>
<style scoped lang="sass">
@import './../../assets/sass/product/producttooltip'
.v-progress-circular
    top:25%   
</style>